import { Aviso } from "./aviso";

export class Endereco {
    nuTransacao: string;
    nuProtocolo: string;
    cdRetorno: string;
    cdMsgemRetorno: string;
    dsMsgemRetorno: string;
    dsMsgemMainframeRetorno: string;
    nuControle: string;
    nuDocumento: string;
    cdCtrlProcessamento: string;
    textoAutenticacao: string;
    cdIndcdTransacao: string;
    lstMensagem: Array<Aviso>;
    cdIndicadorDsCorrep: string;
    tpPessoa: string;
    tpEndereco: string;
    dsEndereco: string;
    nuEndereco: number;
    dsComplemento: string;
    dsBairro: string;
    dsCidade: string;
    cdUf: string;
    cdCep: string;
    cdCep1: string;
    cdCep2: string;

    constructor() {
    }
}

export class EfetivarEnderecoRequest {
  nuCTRL: string;
  nuContrato: string;
  dsEndereco: string;
  nuEndereco: string;
  dsComplemento: string;
  dsBairro: string;
  dsCidade: string;
  cdUf: string;
  cdCep: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/endereco.ts